export enum PriceIndexType {
  /**
   * 价格指数
   */
  PRICE_INDEX = 0,

  /**
   * 市场走势
   */
  MARKET_TREND = 1
}
